import React from "react";
import { useSelector } from "react-redux";
import { useWatch } from "react-hook-form";

import { i18, trb } from "@utilities";
import {
  InputFormField,
  SelectFormField,
  CheckboxFormField,
  RadioFormField
} from "@components/FormField/HookFormFields";
import { selectPepList, selectAvailableCountryOptions } from "@redux";
import { FullWidthInputWrapper, HalfWidthInputWrapper, StepperFormRow } from "@components";
import { yesNo } from "@config/StepperForm";

export const ClientPolitics = ({ control, resetOtherField, resetPoliticsFields }) => {
  const pepList = useSelector(selectPepList);
  const availableCountries = useSelector(selectAvailableCountryOptions);

  const hasPoliticsMember = useWatch({
    control,
    name: "clientProfile.0.data.clientPoliticsMember"
  });
  const clientPoliticsOther = useWatch({
    control,
    name: "clientPoliticsPosition.0.data.clientPoliticOther"
  });

  const clientPoliticsCheckboxes = [
    {
      label: trb(i18.Labels.ClientPoliticsMinist),
      value: "clientPoliticsPosition.0.data.clientPoliticsMinist"
    },
    {
      label: trb(i18.Labels.ClientPoliticsParl),
      value: "clientPoliticsPosition.0.data.clientPoliticsParl"
    },
    {
      label: trb(i18.Labels.ClientPoliticsJutge),
      value: "clientPoliticsPosition.0.data.clientPoliticsJutge"
    },
    {
      label: trb(i18.Labels.ClientPoliticsMay),
      value: "clientPoliticsPosition.0.data.clientPoliticsMay"
    },
    {
      label: trb(i18.Labels.ClientPoliticsAudit),
      value: "clientPoliticsPosition.0.data.clientPoliticsAudit"
    },
    {
      label: trb(i18.Labels.ClientPoliticsMJoint),
      value: "clientPoliticsPosition.0.data.clientPoliticsMJoint"
    },
    {
      label: trb(i18.Labels.ClientPoliticsAmb),
      value: "clientPoliticsPosition.0.data.clientPoliticsAmb"
    },
    {
      label: trb(i18.Labels.ClientPoliticsJoint),
      value: "clientPoliticsPosition.0.data.clientPoliticsJoint"
    },
    {
      label: trb(i18.Labels.ClientPoliticsInternOrg),
      value: "clientPoliticsPosition.0.data.clientPoliticsInternOrg"
    },
    {
      label: trb(i18.Labels.ClientPoliticsPolPart),
      value: "clientPoliticsPosition.0.data.clientPoliticsPolPart"
    },
    {
      label: trb(i18.Labels.ClientPoliticArmForces),
      value: "clientPoliticsPosition.0.data.clientPoliticArmForces"
    },
    {
      label: trb(i18.Labels.ClientPoliticOther),
      value: "clientPoliticsPosition.0.data.clientPoliticOther"
    }
  ];

  return (
    <StepperFormRow>
      <FullWidthInputWrapper>
        <p className="form-group-title">{trb(i18.Labels.PoliticallyExposedPerson)}</p>
      </FullWidthInputWrapper>

      <FullWidthInputWrapper>
        <p className="form-part-description mb-3">
          {trb(i18.Messages.PoliticallyExposedPersonNote)}
        </p>
      </FullWidthInputWrapper>

      <FullWidthInputWrapper>
        <RadioFormField
          control={control}
          name="clientProfile.0.data.clientPoliticsMember"
          title={trb(i18.Labels.ClientPoliticsMember)}
          options={yesNo}
          optionsLabel="label"
          optionsValue="value"
          defaultValue={0}
          onChange={resetPoliticsFields}
          translationGroup={i18.Labels}
        />
      </FullWidthInputWrapper>

      {(hasPoliticsMember === 1 || hasPoliticsMember === "1") && (
        <>
          {/* neccessary for form value */}
          <InputFormField
            control={control}
            name="clientPoliticsPosition.0.ClientPoliticsPosList"
            defaultValue="PEN1"
            className="d-none"
          />
          {clientPoliticsCheckboxes.map(checkbox => (
            <FullWidthInputWrapper
              containerClass="form-step2-checkbox-container"
              key={checkbox.value}
            >
              <CheckboxFormField
                control={control}
                name={checkbox.value}
                label={checkbox.label}
                onChange={
                  checkbox.value === "clientPoliticsPosition.0.data.clientPoliticOther" &&
                  resetOtherField
                }
              />
            </FullWidthInputWrapper>
          ))}
        </>
      )}
      {(clientPoliticsOther === true || clientPoliticsOther === "1") && (
        <FullWidthInputWrapper>
          <InputFormField
            control={control}
            name="clientPoliticsPosition.0.data.clientPoliticOtherInput"
            title={trb(i18.Labels.CompanyFundsOther)}
          />
        </FullWidthInputWrapper>
      )}
      {(hasPoliticsMember === 1 || hasPoliticsMember === "1") && (
        <>
          <FullWidthInputWrapper>
            <p className="form-group-title">{trb(i18.Labels.ClientPoliticsList)}</p>
          </FullWidthInputWrapper>
          {/* neccessary for form value */}
          <InputFormField
            control={control}
            name="clientPoliticsPosition.0.ClientPoliticsPosList"
            defaultValue="PEN1"
            className="d-none"
          />

          <FullWidthInputWrapper>
            <RadioFormField // check if validation required
              control={control}
              name="clientPolitics.0.clientPoliticsList"
              title={trb(i18.Labels.ClientPoliticsType)}
              options={pepList}
              optionsLabel="label"
              optionsValue="value"
            />
          </FullWidthInputWrapper>

          <HalfWidthInputWrapper>
            <InputFormField
              control={control}
              name="clientPolitics.0.data.clientPoliticsName"
              title={trb(i18.Labels.ClientPoliticsName)}
            />
          </HalfWidthInputWrapper>

          <HalfWidthInputWrapper>
            <SelectFormField
              control={control}
              name="clientPolitics.0.data.clientPoliticsCountry"
              title={trb(i18.Labels.ClientPoliticsCountry)}
              options={availableCountries}
              optionsLabel="label"
              optionsValue="value"
              isSearchable
              defaultValue="LT"
            />
          </HalfWidthInputWrapper>

          <HalfWidthInputWrapper>
            <InputFormField
              control={control}
              name="clientPolitics.0.data.pepInstitution"
              title={trb(i18.Labels.PepInstitution)}
            />
          </HalfWidthInputWrapper>

          <HalfWidthInputWrapper>
            <InputFormField
              control={control}
              name="clientPolitics.0.data.clientPep_Id"
              title={trb(i18.Labels.ClientPep_Id)}
            />
          </HalfWidthInputWrapper>
        </>
      )}
    </StepperFormRow>
  );
};
